import { render, staticRenderFns } from "./Cuentas.vue?vue&type=template&id=06c326b4&scoped=true"
import script from "./Cuentas.vue?vue&type=script&lang=js"
export * from "./Cuentas.vue?vue&type=script&lang=js"
import style0 from "./Cuentas.vue?vue&type=style&index=0&id=06c326b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c326b4",
  null
  
)

export default component.exports